import CommandManager from "../../../core/src/commands/CommandManager";
import GameModel from "../../../core/src/model/GameModel";
import SpinModel from "../../../core/src/model/SpinModel";
import { ICondition } from "../../../core/src/states/State";
import { VendorCommandsEnum } from "../../commands/VendorCommandsEnum";
import JackpotsModel from "../../model/JackpotsModel";

export default class HasJackpotWonCondition implements ICondition {
    check() {
        const result = (!SpinModel.isInFreespins()) && (JackpotsModel.winAmount > 0);
        if (result) {
            CommandManager.execute(VendorCommandsEnum.UPDATE_JACKPOTS);
        }

        return result;
    };
};
